/*
  ForgotPassword - Handles a user trying to reset password uses a firebase method to handle the form generation 

  routeToSuccess - navigates users to the login page to retry their login with newCredentials
  handleReset - does form validation to check if basic input requirements are met; if they are met then they are
                set the a passwordReset page generated by Firebase
*/
/*
  ForgotPassword - Handles a user trying to reset password uses a firebase method to handle the form generation 

  routeToSuccess - navigates users to the login page to retry their login with newCredentials
  handleReset - does form validation to check if basic input requirements are met; if they are met then they are
                set the a passwordReset page generated by Firebase
*/
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ButtonPrimary } from "./Buttons";
import { passwordReset } from "../firebase/auth.js";
import Input from "./Input";

function ForgotPassword(props) {
  const [values, setValues] = useState({
    email: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate(); // Add this line to get the navigate function

  const routeToSuccess = async () => {
    navigate("/admin/login"); //change this to check to see where the user is routing from and route them correctly
  };

  const handleReset = async () => {
    var user;
    if (!values.email) {
      setErrorMessage("You must provide an email.");
      return;
    }
    try {
      user = passwordReset(values.email);
    } catch (error) {
      alert("Reset password could not be processed");
    }
    alert(user);
    if (user) {
      routeToSuccess(); //for now nothing is being passed when they are routed to dashboard their name displays??
    } else {
      setErrorMessage("Could not be processed.");
    }
  };

  return (
    <div className="ForgotPassword">
      <h4>Forgot Password</h4>
      <Input
        type="email"
        label="GGC Email"
        placeholder="Please enter your GGC Email to reset password"
        onChange={(event) =>
          setValues((prev) => ({ ...prev, email: event.target.value }))
        }
      />

      <ButtonPrimary
        text="Reset Password"
        onClick={handleReset}
        style={{ margin: "auto" }}
      />

      <div className="my-0">
            <Link to="/SimpleLogin" className="text-decoration-none text-primary">
               Click here
            </Link>&nbsp;to return to the login page
      </div>
      

      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

      {props.haveAccount && (
        <p>
          Already have an account?{" "}
          <span>
            <Link to="/admin/login">Login</Link>
          </span>
        </p>
      )}
    </div>
  );
}

export default ForgotPassword;
